import { useState, useEffect } from "react"
import { Container, Col, Row, Form, Card, Button, Stack, InputGroup } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { setFirstName, setLastLoginDate, setLastName, setPsoName, setPsoId, setToken, setUsername, setMfaToken, setRole } from "Store/LoginInfoSlice";
import { httpLogin } from "Utils/httpLogin";
import ErrorIcon from '@mui/icons-material/ErrorOutlined';
import { TextButton } from 'Components/Button';
import MfaTokenPopup from "./Popup/MfaTokenPopup";
import { PageInfo } from "Components/PageInformation/PageInformation";
import { ERROR_MESSAGES, ROLES } from "Utils/constants";
import { setGlobalErrorStatus, setGlobalSuccessStatus } from 'Components/StatusHandling';
import ForgotPasswordEmailPopup from "./Popup/ForgotPasswordEmailPopup";

const Login = ({
  closeCollapsedSideNav
}) => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const passedData = location.state;

  // validationMsg before send it to the java backend: 
  // {
  //    "email": {
  //             inValid: true/false
  //             msg: []
  //           },
  //     "password": {
  //             inValid: true/false
  //             msg: []
  //           }
  // }
  const [validationMsg, setValidationMsg] = useState({});
  const [globalErrorList, setGlobalErrorList] = useState([]);
  const [showHidePWDFlag, setShowHidePWDFlag] = useState(false);
  const [showMfaPopup, setShowMfaPopup] = useState(false);
  const [showForgotPasswordEmailPopup, setShowForgotPasswordEmailPopup] = useState(false);

  // display message if there is when page init: 
  // Ex. Reset password success message
  useEffect(() => {
    //console.log("login in page init", passedData?.message);
    if (passedData?.message) {
      setGlobalSuccessStatus({
        dispatch: dispatch,
        popupData: {
          visible: true,
          title: "Success!",
          msg: passedData?.message,
          showContactHelp: false
        },
        redirect: {
          redirect: false,
          redirectFirst: false,
          path: "",
          data: {}
        }
      });
      // clear location state
      window.history.replaceState({}, '');
    }
  }, [])

  useEffect(() => {
    //const errorState = store.getState().errorInfo;
    //console.log(errorState);
    dispatch(setToken(""));
    closeCollapsedSideNav();
  }, []);

  const [loginInfo, setLoginInfo] = useState({
    email: "",
    password: ""
  })

  // const handleUnauthReturn = () => {
  //   //console.log("unauth");
  // }

  const handleEmailChange = (e) => {

    const value = e.target.value;

    let validation = {};

    if (validationMsg.password) {
      validation = { "password": validationMsg.password };
    }

    setLoginInfo({
      ...loginInfo,
      email: value
    });

    setValidationMsg(validation);
  }

  const handlePasswordChange = (e) => {
    const value = e.target.value;

    let validation = {};

    if (validationMsg.email) {
      validation = { "email": validationMsg.email };
    }

    setLoginInfo({
      ...loginInfo,
      initPassword: false,
      password: value
    });

    setValidationMsg(validation);
  }

  const handleSignIn = async () => {

    // validation
    let validation = {};


    if (loginInfo.email === "") {
      let arr = [];
      arr.push("Email is required.");
      validation = {
        ...validation,
        "email": {
          inValid: true,
          msg: arr
        }
      };
    }

    if (loginInfo.password === "") {
      let arrPwd = [];
      arrPwd.push("Password is required.");
      validation = {
        ...validation,
        "password": {
          inValid: true,
          msg: arrPwd
        }
      };
    }

    setValidationMsg(validation);
    setGlobalErrorList([]);

    if (Object.keys(validation).length === 0) {
      const formData = {
        username: loginInfo.email,
        password: loginInfo.password
      }

      const res = await submitLogin(formData)
      //console.log("print out login res", res);
      if (res && res.status === 200) {
        setLoginInfo({
          email: "",
          password: ""
        })

        dispatch(setUsername(loginInfo.email));
        //dispatch(setToken(res.headers["authorization"]));

        if (res.data.data.isUserMfaEnabled === true) {
          dispatch(setMfaToken(res.headers["authorization"]));
          setShowMfaPopup(true);
        } else {
          dispatch(setFirstName(res.data.data.userInfoDisplay.firstName));
          dispatch(setLastName(res.data.data.userInfoDisplay.lastName));
          dispatch(setPsoName(res.data.data.userInfoDisplay.psoName));
          dispatch(setPsoId(res.data.data.userInfoDisplay.psoId));
          dispatch(setLastLoginDate(res.data.data.userInfoDisplay.lastLoginDateString));
          dispatch(setToken(res.headers["authorization"]));
          dispatch(setRole(res.data.data.userInfoDisplay.userRole.roleName));

          var userRole = res.data.data.userInfoDisplay.userRole.roleName;
          if (userRole == ROLES.L1.id || userRole == ROLES.AUSER.id) {
            navigate("/helpcenter");
          }
          else {
            navigate("/dashboard");
          }
        }
      } else {
        // error handling: 
        setGlobalErrorList(res.data.globalErrorMessageList);
      }
    }
  }

  const submitLogin = async (formData) => {

    const res = httpLogin.post('/auth/login', formData, {
      headers: {
        //"Content-Type": "multipart/form-data"
      }
    }).catch(function (error) {
      //console.log("submitLogin error", error);
      if (error.response?.status !== 401) {
        setGlobalErrorStatus({
          dispatch: dispatch,
          popupData: {
            visible: true,
            title: ERROR_MESSAGES.GENERAL_ERROR.title,
            msg: ERROR_MESSAGES.GENERAL_ERROR.message,
            showContactHelp: true
          },
          redirect: {
            redirect: false,
            redirectFirst: false,
            path: "",
            data: {}
          },
          error: error
        });
      }
      return error.response;
    });;

    return res;
  }

  // password show and hide
  const showHidePWD = () => {
    setShowHidePWDFlag(!showHidePWDFlag);
  }

  const handleClose = () => {
    setShowMfaPopup(false);
  }

  const handleCloseForgotPasswordEmailPopup = () => {
    setShowForgotPasswordEmailPopup(false);
  }

  const handleShowForgotPasswordEmailPopup = () => {
    setShowForgotPasswordEmailPopup(true);
  }

  return (
    <Container>
      <MfaTokenPopup show={showMfaPopup} handleClose={handleClose} />
      <ForgotPasswordEmailPopup
        show={showForgotPasswordEmailPopup}
        handleClose={handleCloseForgotPasswordEmailPopup}
      ></ForgotPasswordEmailPopup>
      <Row id="signInPage" className="contentBackground">
        <Col xl={6} lg={11} md={11} sm={12} className="ms-auto me-auto">
          <Card className="p-4" >
            <Card.Body className="text-start">
              <Row>
                <h1 id="mainContent" className="text-center mb-3 black regular">Sign In</h1>
              </Row>
              <p className="text-center mb-3">Enter your email and password to access your account</p>
              {globalErrorList.map((item, index) =>
                <PageInfo key={"errors_" + index} type="error" message={item}></PageInfo>
              )}
              <Form className="mt-3">
                <Form.Group className="mb-3" as={Col} controlId="email" style={{ textAlign: 'left', fontWeight: '600' }}>
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter your email"
                    value={loginInfo.email}
                    isInvalid={validationMsg.email?.inValid}
                    onChange={handleEmailChange}
                  />
                  <Form.Control.Feedback type="invalid" className="fieldErrorMsg">
                    {validationMsg.email?.msg.map((item, index) =>
                      <Stack key={"errors_" + index} direction="horizontal" gap={2} className="align-items-start">
                        <div id="errorIcon"><ErrorIcon fontSize="small"></ErrorIcon></div>
                        <div>{item}</div>
                      </Stack>)}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-2" as={Col} controlId="passwordField" style={{ textAlign: 'left', fontWeight: '600' }}>
                  <Form.Label>Password</Form.Label>
                  <InputGroup>
                    <Form.Control
                      id="passwordField"
                      type={showHidePWDFlag ? "text" : "password"}
                      placeholder="Enter your password"
                      value={loginInfo.password}
                      isInvalid={validationMsg.password?.inValid}
                      onChange={handlePasswordChange}
                    />
                    <Button
                      id="showPassword"
                      onClick={showHidePWD}
                      className="smallText"
                    >
                      {showHidePWDFlag ? "Hide" : "Show"}
                    </Button>
                    <Form.Control.Feedback type="invalid" className="fieldErrorMsg">
                      {validationMsg.password?.msg.map((item, index) =>
                        <Stack key={"errors_" + index} direction="horizontal" gap={2} className="align-items-start">
                          <div id="errorIcon"><ErrorIcon fontSize="small"></ErrorIcon></div>
                          <div>{item}</div>
                        </Stack>)}
                    </Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>

                <p className="smallText text-end mb-4"><a href="#" onClick={handleShowForgotPasswordEmailPopup}>Forgot Password?</a></p>
                {/* Submit Button */}
                <TextButton
                  className="w-100"
                  variant="normal"
                  onClick={handleSignIn}
                  content={"Sign In"}
                >
                </TextButton>
                <p className="smallText text-center mt-5">Don't have an account? <a href="#">Learn More</a></p>
                <p className="smallText text-center mt-5">By signing in you agree to the <a href="#">Terms of Use</a></p>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default Login;